import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useAdContext } from '../../../store/contexts/ad';

import { MenuButton, Section } from '@icarros/ids-react';

import { Deactivate } from '../../listing/components/Modal';
import { LISTING, OFFERS, PERFORMANCE } from '../../../../utils/routes';

import { ReactComponent as AdIcon } from '../../../../assets/rebranding/icons/anuncio.svg';

import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';

import { ActionCenterWrapper, MenuButtonGrid } from './style';
import { IconWrapper } from '../style';
import { STATUS } from '../../../enum/listing-status';

export function ActionsCenter(): JSX.Element {
  const history = useHistory();
  const { currentAd } = useAdContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [showDeactivate, setShowDeactivate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const { filterName, link, id } = currentAd || {};

  function handleDelete() {
    setShowDelete(true);
    setModalOpen(true);
    setShowDeactivate(false);
  }

  function handleDeactivate() {
    setModalOpen(true);
    setShowDeactivate(true);
    setShowDelete(false);
  }

  return (
    <ActionCenterWrapper>
      <Section>o que deseja fazer?</Section>
      <MenuButtonGrid>
        {(filterName === STATUS.active || filterName === STATUS.expired) && (
          <>
            <MenuButton
              size="large"
              variant="neutral"
              iconName="itaufonts_sms_mensagem_chat"
              textLabel="acessar mensagens"
              onClick={() => {
                pushSellerPFDashboardEvent('acessar mensagens', 'o que deseja fazer?');
                history.push(`${OFFERS}/${id}`);
              }}
            />
            <MenuButton
              size="large"
              variant="neutral"
              iconName="itaufonts_investimento"
              textLabel="acessar performance"
              onClick={() => {
                pushSellerPFDashboardEvent('acessar performance', 'o que deseja fazer?');
                history.push(`${LISTING}/${id}${PERFORMANCE}`);
              }}
            />
          </>
        )}
        {filterName === STATUS.active && (
          <>
            <MenuButton
              size="large"
              variant="neutral"
              iconElement={
                <IconWrapper>
                  <AdIcon width={32} height={32} />
                </IconWrapper>
              }
              textLabel="exibir anúncio"
              onClick={() => {
                pushSellerPFDashboardEvent('exibir anúncio', 'o que deseja fazer?');
                window.open(link, '_blank');
              }}
            />
            <MenuButton
              size="large"
              variant="neutral"
              iconName="itaufonts_switch"
              textLabel="desativar anúncio"
              onClick={() => {
                pushSellerPFDashboardEvent('desativar anúncio', 'o que deseja fazer?');
                handleDeactivate();
              }}
            />
          </>
        )}

        {filterName !== STATUS.active && (
          <MenuButton
            size="large"
            variant="neutral"
            iconName="itaufonts_excluir"
            textLabel="excluir anúncio"
            onClick={() => {
              pushSellerPFDashboardEvent('excluir anúncio', 'o que deseja fazer?');
              handleDelete();
            }}
          />
        )}
        <MenuButton
          size="large"
          variant="neutral"
          iconName="itaufonts_ajuda"
          textLabel="preciso de ajuda"
          onClick={() => {
            pushSellerPFDashboardEvent('preciso de ajuda', 'o que deseja fazer?');
            window.open('https://icarros.zendesk.com/hc/pt-br', '_blank', 'noopener');
          }}
        />
      </MenuButtonGrid>

      {typeof id == 'number' && id > 0 && (
        <>
          {showDeactivate && modalOpen && (
            <Deactivate modalOpen={modalOpen} setModalOpen={setModalOpen} adId={id} />
          )}
          {showDelete && modalOpen && (
            <Deactivate modalOpen={modalOpen} setModalOpen={setModalOpen} adId={id} isDelete />
          )}
        </>
      )}
    </ActionCenterWrapper>
  );
}
